export function filterSummary(options, selected, emptyLabel) {
  if (!selected.length) return emptyLabel
  const first = options.find(option => option.value === selected[0])?.label || selected[0]
  return selected.length > 1 ? `${first} +${selected.length - 1}` : first
}
